<template>
  <v-menu
    offset-y
    left
    nudge-bottom="14"
    min-width="230"
    content-class="user-profile-menu-content"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-badge
        bottom
        color="success"
        overlap
        offset-x="8"
        offset-y="8"
        class="ms-4"
        dot
      >
        <v-avatar
          size="32px"
          v-bind="attrs"
          v-on="on"
        >
          <v-img :src="getAvatarUrl()"></v-img>
        </v-avatar>
      </v-badge>
    </template>
    <v-list>
      <div class="pb-3 pt-2">
        <v-badge
          bottom
          color="success"
          overlap
          offset-x="12"
          offset-y="12"
          class="ms-4"
          dot
        >
          <v-avatar size="40px">
            <v-img :src="getAvatarUrl()"></v-img>
          </v-avatar>
        </v-badge>
        <div
          class="d-inline-flex flex-column justify-center ms-3"
          style="vertical-align:middle"
        >
          <span class="text--primary font-weight-semibold mb-n1">
            {{ getFullName() }}
          </span>
          <small v-if="roleLabel" class="text--secondary text-caption font-weight-medium mt-1">
            {{ roleLabel }}
          </small>
        </div>
      </div>

      <v-divider></v-divider>

      <!-- Profile (dynamic authenticated user id) -->
      <v-list-item link :to="profileRoute">
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiAccountOutline }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ $t("profile") }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- Settings (Super Admin only) -->
      <v-list-item v-if="!isRouteMaking && !isOperations" link to="/settings">
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiCogOutline }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ $t("settings") }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>


      <v-divider class="my-2"></v-divider>

      <!-- Logout -->
      <v-list-item link @click="logout">
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiLogoutVariant }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ $t("logout") }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>

import auth, { getUserRole, getCurrentUser } from '@/services/AuthService'

import {
  mdiAccountOutline,
  mdiEmailOutline,
  mdiCheckboxMarkedOutline,
  mdiChatOutline,
  mdiCogOutline,
  mdiCurrencyUsd,
  mdiHelpCircleOutline,
  mdiLogoutVariant,
} from '@mdi/js'

import {Keys} from '/src/config.js'

export default {
  components: {
    Keys
  },
  computed: {
    isRouteMaking() {
      return getUserRole() === 3;
    },
    isOperations() {
      return getUserRole() === 4;
    },
    currentUser() {
      return getCurrentUser();
    },
    displayName() {
      if (this.currentUser && this.currentUser.name) {
        return this.currentUser.name;
      }
      return this.adminName || '';
    },
    roleLabel() {
      if (this.isOperations) {
        return 'Operations';
      }
      if (this.isRouteMaking) {
        return 'Route Making';
      }
      if (this.currentUser && (this.currentUser.role === 0 || this.currentUser.role === '0')) {
        return 'Admin';
      }
      return '';
    },
    profileRoute() {
      const id = this.currentUser && this.currentUser.id ? this.currentUser.id : 1;
      return `/users/view/user=${id}`;
    }
  },
  //props
  props: {
    adminName: {
      type: String,
      default: '',
    },
    adminAvatar: {
      type: String,
      default: '',
    },
  },
  setup() {
    return {
      icons: {
        mdiAccountOutline,
        mdiEmailOutline,
        mdiCheckboxMarkedOutline,
        mdiChatOutline,
        mdiCogOutline,
        mdiCurrencyUsd,
        mdiHelpCircleOutline,
        mdiLogoutVariant,
      },
    }
  },
  methods: {
    getAvatarUrl() {
      if (this.currentUser && this.currentUser.avatar) {
        return Keys.VUE_APP_API_URL + this.currentUser.avatar;
      }
      if (!this.isRouteMaking && !this.isOperations && this.adminAvatar) {
        return Keys.VUE_APP_API_URL + this.adminAvatar;
      }
      return require('@/assets/images/avatars/1.png');
    },
    getFullName() {
      return this.displayName;
    },
    logout()
    {
      auth.logout()
    }
  }
}
</script>

<style lang="scss">
.user-profile-menu-content {
  .v-list-item {
    min-height: 2.5rem !important;
  }
}
</style>
